<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage">
<a id="title41"></a>
<div class="verse"><span>Foul deeds will rise,<br/> Though all the earth o’erwhelm them, to men’s eyes.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="source"><span>—WILLIAM SHAKESPEARE<br/> <em class="i">Hamlet</em></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="verse"><span>Be not deceived; God is not mocked:<br/> For whatsoever a man soweth,<br/> That shall he also reap.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="source"><span>—Galatians, Chapter 6, Verse 7</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429997973_epi01.vue?18a55634